import { ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

interface INoItem {
  title?: string;
  desc?: string;
  icon?: IconDefinition;
  action?: ReactNode;
}

const NoItem = ({
  title = "No logs found",
  desc = "There are no log entries to display yet.",
  icon = faInbox,
  action,
}: INoItem) => {
  return (
    <div className="flex min-h-[240px] w-full items-center justify-center px-6 py-12">
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-overlay-mid text-[18px] text-light-gray">
          <FontAwesomeIcon icon={icon} />
        </div>
        <h2 className="font-[Gilroy-Bold] text-[16px] text-heading-color">{title}</h2>
        <p className="mt-1 font-[Gilroy-Medium] text-[14px] text-light-gray">{desc}</p>
        {action ? <div className="mt-4">{action}</div> : null}
      </div>
    </div>
  );
};

export default NoItem;
